import { AppStore as store } from '../store/AppStore';
import { ECommonDialogType } from '../data/Constants';
import { openDialog } from '../store/states/DialogSlice';
import { t } from 'i18next';
import { AxiosResponse } from 'axios';

import type { IApiError } from '../../types/IApiTypes';

export const errorHandle = (error: IApiError) => {
  if (
    error &&
    (error.response.status === 404 ||
      error.response.status === 500 ||
      error.response.status === 400)
  ) {
    const dialogData = {
      show: true,
      type: ECommonDialogType.Error,
      data: error.response.data.Message,
    };
    store.dispatch(openDialog(dialogData));
  }
};

export const successHandle = (resSuccess: AxiosResponse) => {
  let dialogData = {
    show: true,
    type: ECommonDialogType.Success,
    data: t('messages.category.savedSuccessfully'),
  };
  if (resSuccess) {
    store.dispatch(openDialog(dialogData));
  } else {
    dialogData = { ...dialogData, type: ECommonDialogType.Error };
    store.dispatch(openDialog(dialogData));
  }
};
